import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
// import Sidebar from "../../common/Sidebar - Copy";
import Sidebar from "../../common/Sidebar";
import Footer from "../../common/Footer";
import axios from 'axios';
import { getToken, triggerAlert } from '../../utils'
import Loader from "../../common/Loader";
import DashboardSectionOne from "./DashboardSectionOne";
// import DashboardSectionTwo from "./DashboardSectionTwo";
import CountUp from 'react-countup';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
function Dashboard() {
    document.title = "SmartInvestorDeck - Dashboard"
    const api_url = process.env.REACT_APP_API_BASE_URL;
    const api = process.env.REACT_APP_CUSTURL;
    const token = Cookies.get('admin_user_token');
    const [isLoading, setIsLoading] = useState(false);
    const [dashboardCounts, setDashboardCounts] = useState(null);
    const navigate = useNavigate();
    const fetchData = async () => {
        // setIsLoading(true);
        try {
            const response = await axios.get(api_url + `dashboard/get_dashboard_count`, token);

            const response_data = response.data;
            // console.log('response_dataCards', response_data);

            if (response_data.error_code === 200) {
                const itemsArray = response_data.results.data
                // console.log('status', dashboardCounts.ticket_data[0].status)
                setDashboardCounts(itemsArray);
                // setIsLoading(false);
            } else if (response.status === 204) {
                setDashboardCounts([]);
                // setIsLoading(false);
            } else {
                triggerAlert('error', 'Oops...', "Couldn't get the card details");
            }
        } catch (error) {
            // setIsLoading(false);
            triggerAlert("error", "Oops...", "Something went wrong..");
        }
    };

    useEffect(() => {
        // fetchData();
        getcustomerlist()
        // alert('I am called')
    }, [])
    const [customercount, setcustomercount] = useState([])
    const getcustomerlist = async () => {
        try {
            const response = await axios.get(`/apiV1/dashboard/customer_status_count`);
            if (response.data) {
                let results = response.data;
                setcustomercount(results)


            }
        } catch (error) {
            console.log("not found");

        }
    };

    const [openticketsview, setopenticketsview] = useState({})
    const [totallist, settotallist] = useState([{}])
    useEffect(() => {

        getcustomerlist1()
    }, [])
    const getcustomerlist1 = async () => {
        try {
            const response = await axios.get(`/apiV1/dashboard/get_dashboard_count`);
            if (response.data) {
                let results = response.data.results;
                setopenticketsview(results)


            }
        } catch (error) {
            console.log("not found");

        }
    };




    return (
        <>
            <div id="layout-wrapper">

                <Header />
                <Sidebar />

                {/* <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== --> */}
                <div className="main-content">

                    <div className="page-content" style={{ backgroundColor: "#ededed" }}>
                        <div className="container-fluid" style={{boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",padding: "15px",borderRadius: "10px",marginBottom:"10px",backgroundColor:"#fff"}}>

                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0 font-size-18">Dashboard</h4>

                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                {/* <!-- <li className="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                                            <li className="breadcrumb-item active">Horizontal</li> --> */}
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                {/* Container for the first three cards */}
                                <div className="col-xxl-6 col-xl-6 col-lg-6 pt-4">


                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="card-title mb-0 flex-grow-1 card-title-custom">
                                                Customer status
                                            </h4>
                                            <hr />
                                        </div>

                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm" 
                                            // onClick={() =>  navigate("/customers/customerslist")}style={{ cursor: "pointer" }}
                                            >
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">Total Customers</h5>
                                                            {/* <h4 className="fw-bold">{customercount.total_customers}</h4> */}
                                                            <h4><CountUp start={0} end={customercount.total_customers} duration={5}/></h4>
                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div className="rounded-circle  d-flex align-items-center justify-content-center" style={{ width: "56px", height: "56px", backgroundColor: "rgb(6, 100, 152)" }}>
                                                                <i className="fa fa-user-plus text-white fs-4" aria-hidden="true"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Active Customer Card */}
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm" 
                                            // onClick={() =>  navigate("/customers/customerslist?is_deleted=1") }style={{ cursor: "pointer" }}
                                                >
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">Active Customers</h5>
                                                            {/* <h4 className="fw-bold">{customercount.total_active_cust}</h4> */}
                                                             <h4><CountUp start={0} end={customercount.total_active_cust} duration={5}/></h4>
                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div
                                                                className="rounded-circle  d-flex align-items-center justify-content-center"
                                                                style={{ width: "56px", height: "56px", backgroundColor: "rgb(102 163 33)" }}
                                                            >
                                                                <i className="fa fa-users text-white fs-4" aria-hidden="true"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Inactive Customer Card */}
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm"
                                            //  onClick={() =>  navigate("/customers/customerslist?is_deleted=2") } style={{ cursor: "pointer" }}
                                             >
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">Inactive Customers</h5>
                                                            {/* <h4 className="fw-bold">{customercount.total_inactive_cust}</h4> */}
                                                             <h4><CountUp start={0} end={customercount.total_inactive_cust} duration={5}/></h4>
                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div
                                                                className="rounded-circle  d-flex align-items-center justify-content-center"
                                                                style={{ width: "56px", height: "56px", backgroundColor: "rgb(201, 93, 56)" }}
                                                            >
                                                                <i className="fa fa-user-times text-white fs-4" aria-hidden="true"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* Container for the next three cards */}
                                <div className="col-xxl-6 col-xl-6 col-lg-6 pt-4">

                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="card-title mb-0 flex-grow-1 card-title-custom">
                                                Ticket status
                                            </h4>
                                            <hr />
                                        </div>

                                        {/* Open Ticket Card */}
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm">
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">Open Ticket</h5>
                                                            {/* <h4 className="fw-bold">{openticketsview.Open}</h4> */}
                                                             <h4><CountUp start={0} end={openticketsview.Open} duration={5}/></h4>
                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div
                                                                className="rounded-circle  d-flex align-items-center justify-content-center"
                                                                style={{ width: "56px", height: "56px",backgroundColor:"rgb(102 163 33)" }}
                                                            >
                                                                <i className="fa fa-hourglass-start text-white fs-4"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* In Progress Ticket Card */}
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm">
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">In Progress</h5>
                                                            {/* <h4 className="fw-bold">{openticketsview.Pending}</h4> */}
                                                             <h4><CountUp start={0} end={openticketsview.Pending} duration={5}/></h4>

                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div
                                                                className="rounded-circle  d-flex align-items-center justify-content-center"
                                                                style={{ width: "56px", height: "56px",backgroundColor: "rgb(6, 100, 152)" }}
                                                            >
                                                                <i className="fa fa-hourglass-half text-white fs-4"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Close Ticket Card */}
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-4 col-sm-6 col-12">
                                            <div className="card shadow-sm">
                                                <div className="card-header bg-transparent border-bottom-0">
                                                    <div className="row align-items-center">
                                                        <div className="col-8">
                                                            <h5 className="mb-1 text-org">Close Ticket</h5>
                                                            {/* <h4 className="fw-bold">{openticketsview.Closed}</h4> */}
                                                            <h4><CountUp start={0} end={openticketsview.Closed} duration={5}/></h4>

                                                        </div>
                                                        <div className="col-4 text-end">
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{ width: "56px", height: "56px", backgroundColor: "rgb(201, 93, 56)" }}
                                                            >
                                                                <i className="fa fa-hourglass-end text-white fs-4"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>













                            {/* <!-- end row--> */}
                            <DashboardSectionOne />
                            {/* <DashboardSectionTwo /> */}


                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}

                    <Footer />
                </div>
                {/* <!-- end main content--> */}
            </div>
            {/* <!-- END layout-wrapper --> */}

            {/* <!-- Right bar overlay--> */}
            <div className="rightbar-overlay"></div>
        </>
    );
}

export default Dashboard;